// extracted by mini-css-extract-plugin
module.exports = {"section":"section__172T3","deadline-box":"deadline-box__2i5nz","deadline":"deadline__1b5_O","no":"no__2u6LV","note":"note__2dxvO"};